import React from "react";
import InsightVibeCheck from "./components/InsightVibeCheck.jsx";
import "./App.css";

function App() {
  return (
    <div className="App">
      <InsightVibeCheck />
    </div>
  );
}

export default App;
